import DeleteFlagContainer from "./DeleteFlagContainer";
export default DeleteFlagContainer;
